import { render, staticRenderFns } from "./NewConfirmationDialog.vue?vue&type=template&id=58fa32c0&scoped=true"
import script from "./NewConfirmationDialog.vue?vue&type=script&lang=js"
export * from "./NewConfirmationDialog.vue?vue&type=script&lang=js"
import style0 from "./NewConfirmationDialog.vue?vue&type=style&index=0&id=58fa32c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58fa32c0",
  null
  
)

export default component.exports